document.addEventListener('DOMContentLoaded', () => {
    const heroButton = document.querySelector('.section-white-button');
    if (heroButton) {
        heroButton.addEventListener('click', function (e) {
            const targetId = this.closest('a')?.getAttribute('href');
            if (targetId && targetId.startsWith('#')) {
                const target = document.querySelector(targetId);
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }
});